import React from 'react'
import { Table } from 'reactstrap'
import { CommonTableProps } from '../../../../../Types/TableType'

export default function CommonTable({ tableClass, strip, caption, size, hover, headClass = '', headRowClass = '', headData, children }:CommonTableProps) {
    return (
        <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "65vh", position: "relative" }}>
            <Table
                className={tableClass}
                striped={strip}
                hover={hover}
                size={size}
                style={{
                    marginBottom: 0,
                    borderCollapse: "separate",
                    borderSpacing: 0,
                }}
            >
                {caption && <caption>{caption}</caption>}
                <thead className={headClass} style={{ position: "sticky", top: 0, zIndex: 2 }}>
                    <tr className={headRowClass}>
                        {headData.map((head) => (
                            <th
                                key={head.id}
                                scope="col"
                                style={{
                                    padding: '8px 10px',
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 2,
                                    backgroundColor: '#f8f9fa',
                                    boxShadow: 'inset 0 -2px 0 #dee2e6',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {head.head}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>{children}</tbody>
            </Table>
        </div>
    )
}


// interface HeadDataItem {
//   id: string;
//   head: string | JSX.Element;
//   key: string;
//   sortKey?: string | null;
// }

// interface CommonTableNewProps {
//   tableClass?: string;
//   strip?: boolean;
//   caption?: string;
//   size?: string;
//   hover?: boolean;
//   headClass?: string;
//   headRowClass?: string;
//   headData: HeadDataItem[];
//   data: any[];
//   renderRow: (row: any, index: number) => React.ReactNode;
// }

// const CommonTableNew: React.FC<CommonTableNewProps> = ({
//   tableClass,
//   strip,
//   caption,
//   size,
//   hover,
//   headClass = '',
//   headRowClass = '',
//   headData,
//   data,
//   renderRow,
// }) => {
//   const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' } | null>(null);
//   const [filters, setFilters] = useState<Record<string, string>>({});
//   const [visibleFilters, setVisibleFilters] = useState<Record<string, boolean>>({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const handleSort = (key: string) => {
//     setSortConfig(prev =>
//       prev?.key === key
//         ? { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
//         : { key, direction: 'asc' }
//     );
//   };

//   const handleFilterChange = (key: string, value: string) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//     setCurrentPage(1);
//   };

//   const toggleFilter = (key: string) => {
//     setVisibleFilters(prev => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   const filteredData = useMemo(() => {
//     let filtered = [...data];
//     Object.entries(filters).forEach(([key, value]) => {
//       if (value) {
//         filtered = filtered.filter(item =>
//           String(item[key] ?? '').toLowerCase().includes(value.toLowerCase())
//         );
//       }
//     });
//     return filtered;
//   }, [data, filters]);

//   const sortedData = useMemo(() => {
//     let sorted = [...filteredData];
//     if (sortConfig?.key) {
//       sorted.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
//         if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
//         if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
//         return 0;
//       });
//     }
//     return sorted;
//   }, [filteredData, sortConfig]);

//   const totalPages = Math.ceil(sortedData.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentRows = sortedData.slice(startIndex, startIndex + rowsPerPage);

//   return (
//     <>
//       <div style={{ overflowX: 'auto' }}>
//         <Table className={tableClass} striped={strip} hover={hover} size={size}>
//           {caption && <caption>{caption}</caption>}
//           <thead className={headClass}>
//             <tr className={headRowClass}>
//               {headData.map((head) => {
//                 const isSortable = !!head.sortKey;
//                 const isActive = sortConfig?.key === head.sortKey;
//                 const direction = sortConfig?.direction;

//                 return (
//                   <th
//                     key={head.id}
//                     style={{
//                       cursor: 'default',
//                       position: 'relative',
//                       userSelect: 'none',
//                       whiteSpace: 'nowrap',
//                       color: isActive ? '#1c65d3' : 'inherit',
//                     }}
//                   >
//                     <div
//                       style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
//                     >
//                       <span
//                         onClick={() => isSortable && handleSort(head.sortKey!)}
//                         style={{ flex: 1, cursor: isSortable ? 'pointer' : 'default' }}
//                       >
//                         {head.head}
//                         {isSortable && (
//                           <span style={{ marginLeft: 4, fontSize: '10px' }}>
//                             {direction === 'asc' ? '▲' : '▼'}
//                           </span>
//                         )}
//                       </span>

//                       {/* 🔍 Search icon */}
//                       <span
//                         style={{
//                           cursor: 'pointer',
//                           marginLeft: 6,
//                           fontSize: '14px',
//                         }}
//                         onClick={() => toggleFilter(head.key)}
//                         title="Search"
//                       >
//                         🔍
//                       </span>
//                     </div>
//                   </th>
//                 );
//               })}
//             </tr>

//             {/* 🔽 Filter row */}
//             <tr>
//               {headData.map(head => (
//                 <th key={`${head.id}-filter`}>
//                   {visibleFilters[head.key] && (
//                     <input
//                       type="text"
//                       value={filters[head.key] || ''}
//                       onChange={(e) => handleFilterChange(head.key, e.target.value)}
//                       placeholder="Search"
//                       style={{
//                         width: '100%',
//                         fontSize: '12px',
//                         padding: '2px',
//                         border: '1px solid #ccc',
//                       }}
//                     />
//                   )}
//                 </th>
//               ))}
//             </tr>
//           </thead>

//           <tbody>
//             {currentRows.map((row, index) => renderRow(row, index))}
//             {currentRows.length === 0 && (
//               <tr>
//                 <td colSpan={headData.length} className="text-center">No data found.</td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       </div>

//       {sortedData.length > 10 && (
//         <div className="d-flex justify-content-between align-items-center px-2 pb-2 flex-wrap gap-2">
//           <div className="p-1">
//             <label className="me-2">Rows per page:</label>
//             <select
//               className="form-select d-inline-block w-auto"
//               value={rowsPerPage}
//               onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
//             >
//               {[10, 25, 50, 100, 500].map(size => (
//                 <option key={size} value={size}>{size}</option>
//               ))}
//             </select>
//           </div>

//           <div className="p-1">
//             <label>
//               Showing {startIndex + 1}–{Math.min(startIndex + rowsPerPage, sortedData.length)} of {sortedData.length} records
//             </label>
//           </div>

//           <div className="p-1">
//             <label>Page {currentPage} of {totalPages}</label>
//             <button
//               disabled={currentPage === 1}
//               className="btn btn-sm btn-outline-primary ms-2"
//               onClick={() => setCurrentPage(p => p - 1)}
//             >
//               Prev
//             </button>
//             <button
//               disabled={currentPage === totalPages}
//               className="btn btn-sm btn-outline-primary ms-2"
//               onClick={() => setCurrentPage(p => p + 1)}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default CommonTableNew;
